import { axiosClient } from '@nx-frontend/shared/api';
import { DeleteTagFromNotePayload } from '@nx-frontend/shared/types';

export const deleteTagFromNote = async ({ workspaceId, noteId, tag }: DeleteTagFromNotePayload): Promise<boolean> => {
  try {
    await axiosClient.delete(`/v2/api/workspaces/${workspaceId}/notes/${noteId}/tags/${encodeURIComponent(tag)}`);
    return true;
  } catch (err) {
    console.log('deleteTagFromNote error:', err);
    return false;
  }
};
